export default __webpack_public_path__ + "static/media/delete_folder_icon.529ad37b.svg";